import { useQuery } from '@tanstack/react-query';

import { LereToursPricingSuggestionsParams } from '~/components/LERE/types';

import LereService from '~/services/LereService';

import { lereToursPricingSuggestionsQueryKeys } from './lereToursPricingSuggestionsQueryKeys';

interface UseGetLereToursPricingSuggestionsOptions {
  enabled?: boolean;
}

export function useGetLereToursPricingSuggestions(
  params: LereToursPricingSuggestionsParams,
  options: UseGetLereToursPricingSuggestionsOptions = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: lereToursPricingSuggestionsQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await LereService.getToursPricingSuggestions(params, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled,
    retry: false,
  });
}
